import { format } from "date-fns";
import useAsyncFunction from "../../hooks/useAsyncFunction"
import BasicTable from "../common/BasicTable";
import Table from "../common/table";
import apiAmbientes from "../../services/apis/apiAmbientes";

export default function AmbienteTable({ equipamento }) {
        
    const { data, loading, error } = useAsyncFunction(async () => await apiAmbientes.getEquipamentoComUltimasLeituras(equipamento.id, 50)) || [];

    if (loading) return <p>Carregando...</p>;

    if(!data || error) {
        return null
    }
        

    const leituras = data?.leiturasAmbientes || [];

    
    return <BasicTable 
        headerContent={["LEITURA ID", "DATA HORA", "TEMPERATURA ATUAL"]} 
    >   
        {
            leituras.map((leitura) => (
            <Table.Row key={leitura.id}>
            <Table.Data>
                    {
                        leitura.id
                    }
                </Table.Data>
                <Table.Data>
                    {
                        format(leitura.dataHora, "dd/MM/yyyy HH:mm:ss") === "01/01/0001 00:00:00" ? 
                        "Sem leitura" : 
                        format(leitura.dataHora, "dd/MM/yyyy HH:mm:ss")
                    }
                </Table.Data>
                <Table.Data>
                    {
                        leitura.temperaturaAtual
                    }
                </Table.Data>
            </Table.Row>
            ))
        }
    </BasicTable>

}